// Constants.
import * as LMSConstants from 'constants/LMSConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  materials: [],
  errorMessage: '',
};

export default function lmsCourseMaterials(state = initialState, action = {}) {
  switch (action.type) {
    case LMSConstants.LOAD_LMS_COURSE_MATERIALS_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case LMSConstants.LOAD_LMS_COURSE_MATERIALS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        materials: action.materials,
      };
    case LMSConstants.LOAD_LMS_COURSE_MATERIALS_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        materials: null,
        errorMessage: action.message,
      };
    case LMSConstants.UPDATE_LMS_COURSE_MATERIAL_REQUEST: {
      const materials = [ ...state.materials ];
      materials.map((material, index) => {
        if (action.material.id === material.id) {
          materials[index] = action.material;
        }
      });
      return {
        ...state,
        materials: materials,
      };
    }
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        materials: null,
        errorMessage: '',
      };
    default:
      return state;
  }
}
